/**
 * WavyDivider — SVG wavy line to replace <hr> and hard borders
 */

import { kidPalette } from '../../styles/kidPalette';

interface WavyDividerProps {
  color?: string;
  amplitude?: number;
  className?: string;
  flip?: boolean;
}

export default function WavyDivider({
  color = kidPalette.ocean,
  amplitude = 8,
  className = '',
  flip = false,
}: WavyDividerProps) {
  const h = amplitude * 2 + 4;

  return (
    <svg
      viewBox={`0 0 1200 ${h}`}
      preserveAspectRatio="none"
      className={`w-full pointer-events-none ${className}`}
      style={{ height: h, transform: flip ? 'scaleY(-1)' : undefined }}
    >
      <path
        d={`M0 ${h / 2} Q150 ${h / 2 - amplitude} 300 ${h / 2} T600 ${h / 2} T900 ${h / 2} T1200 ${h / 2}`}
        fill="none"
        stroke={color}
        strokeWidth={2.5}
        strokeLinecap="round"
        opacity={0.3}
      />
    </svg>
  );
}
